const axios = require('axios');
const API_URL = process.env.CLAIM_ACCUMULATOR_API;

/**
 * @param {string} accumulatorId 
 */
const getAccumulator = async (accumulatorId) => {
    const response = await axios.get(`${API_URL}query/accumulator/${accumulatorId}`);

    if (response.status !== 200) {
        return null;
    }

    return response.data;
}

module.exports = {
    getAccumulator
}